import * as React from 'react';
import $ from "jquery";
import Common from '../utilities/common';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import ErrorDialog from '../utilities/ErrorDialog';

export interface IMunicipioDeleterops {
    open: boolean;
    onClose?: Function;
    onDelete?: Function;
    id: number[];
}

export interface IMunicipioDeleteState {
    open: boolean;
    hasErrors: boolean;
    errorMessage: string;
    openErroDialog: boolean;
}

export default class MunicipioDelete extends React.Component<IMunicipioDeleterops, IMunicipioDeleteState> {
    _selectedItems: number[] = [];

    public constructor(props: IMunicipioDeleterops) {
        super(props);

        this.state = {
            open: false,
            hasErrors: false,
            errorMessage: '',
            openErroDialog: false
        }
    }

    componentWillReceiveProps(nextProps: Readonly<IMunicipioDeleterops>, nextContext: any): void {
        this._selectedItems = nextProps.id;

        this.setState({
            open: nextProps.open
        });
    }

    public render(): React.ReactElement<{}> {
        return (
            <React.Fragment>
                <Dialog open={this.state.open} fullWidth>
                    <DialogTitle>
                        Eliminar municipio
                    </DialogTitle>
                    <DialogContent>
                        {
                            this._selectedItems.length == 1 && (
                                `¿Desea eliminar el municipio seleccionada?`
                            )
                        }
                        {
                            this._selectedItems.length > 1 && (
                                `¿Desea eliminar los municipios seleccionadas?`
                            )
                        }
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.Ok.bind(this)}>OK</Button>
                        <Button onClick={this.Close.bind(this)}>Cancelar</Button>
                    </DialogActions>
                </Dialog>
                <ErrorDialog open={this.state.openErroDialog} onClose={this.Close.bind(this)} />
            </React.Fragment>
        )
    }

    private Ok() {
        this.Delete(0);
    }

    private Close() {
        this.setState(
            {
                open: false,
                hasErrors: false,
                errorMessage: '',
                openErroDialog: false
            }
        );

        if(this.props.onClose != null) {
            this.props.onClose();
        }
    }

    private Delete(index: number): void {
        if(index >= this._selectedItems.length) {
            this.setState(
                {
                    open: false,
                    openErroDialog: false
                }
            );

            if(this.props.onDelete != null) {
                this.props.onDelete();
            }

            return;
        }

        let url = `${Common.END_POINT}/masters/Municipios/${this._selectedItems[index]}/delete`;
        
        $.ajax((
            {
                url: url,
                type: "POST",
                data: this._selectedItems[index].toString(),
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.Delete(index + 1);
        }).fail(() => {
            this.setState(
                {
                    open: false,
                    openErroDialog: false
                }
            );
        })
    }
}